import { Pipe, PipeTransform } from '@angular/core';
import { DatesUtil } from '@shared/utilities/dates/dates.util';
import { ConsolidatedTask } from '../models/task';

@Pipe({
  name: 'taskSort'
})
export class TaskSortPipe implements PipeTransform {
  transform(tasks: ConsolidatedTask.Model[]): ConsolidatedTask.Model[] {
    return tasks.sort((a, b) => {
      //NOTE: this fails at runtime if referencing a method declared on this class.
      let daysA = DatesUtil.offsetInDays(
        DatesUtil.convertToDate(a.due) ?? new Date()
      );
      let daysB = DatesUtil.offsetInDays(
        DatesUtil.convertToDate(b.due) ?? new Date()
      );
      return daysA - daysB;
    });
  }
}
